import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=584a85ab&"
import script from "./emptyData.vue?vue&type=script&lang=js&"
export * from "./emptyData.vue?vue&type=script&lang=js&"
import style0 from "./emptyData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports